import { Row } from "@commonlibs";
import styled, { css } from "styled-components";

export const PartnerOptionRoot = styled(Row)(
    () => css`
        display: grid;
        grid-template-columns: 40px 1fr;
        gap: 15px;
        align-items: center;
        padding: 8px 0px;
        cursor: pointer;
        :first-child {
            padding-top: 0px;
        }
    `,
);

export const PartnerImage = styled.img(
    () => css`
        aspect-ratio: 1/1;
        border-radius: 5px;
        object-fit: cover;
    `,
);
